import { entity } from '@/../region.json';
import i18n from '../../i18n';
import { SHOW_NON_QWELLO_POLES } from '../../shared/entityHelpers';

// To ensure that the translations are updated when the route changes from 'en' -> 'de' etc
// Return initialState as a function.
const initialState = () => ({
  entity,
  SHOW_NON_QWELLO_POLES,
  status: 'IDLE',
  name: {
    state: 'default',
    text: '',
    label: i18n.t('contact.input_name_title'),
    key: 'name',
    type: 'text',
    error: '',
    active: false,
  },
  company: {
    state: 'default',
    text: '',
    label: i18n.t('contact.input_entity_title'),
    key: 'company',
    type: 'text',
    error: '',
    active: false,
  },
  phone: {
    state: 'default',
    text: '',
    label: i18n.t('contact.input_phone_title'),
    key: 'phone',
    type: 'tel',
    error: '',
    active: false,
  },
  email: {
    state: 'default',
    text: '',
    label: i18n.t('contact.input_mail_title'),
    key: 'email',
    type: 'email',
    error: '',
    active: false,
  },
  message: {
    state: 'default',
    text: '',
    label: i18n.t('contact.input_message_title'),
    key: 'message',
    type: 'text',
    error: '',
    active: false,
    wordCount: 1000,
  },
  conditions: false,
});
export default initialState;
